import TextUtils from "@/utils/text-utils";
import {Fonts} from "@/constants/font";
import {Keys} from "@/constants/key";
import SpriteUtils from "@/utils/sprite-utils";

export class ClanShield extends Phaser.GameObjects.Container {

    constructor(scene: Phaser.Scene, clanName: string, x: number, y: number) {
        super(scene);

        this.x = x;
        this.y = y;

        const shield = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_UI, Keys.CLAN_SHIELD);

        let fontSize = clanName.length < 13 ? 14 : 13;
        if (clanName.length > 20) {
            fontSize = 12;
        }

        let titleText = TextUtils.addTextAdvanced(scene, clanName, 0, -3,
            '#ffffff', fontSize, 'normal', 100, 'center', 2, Fonts.BENGALY_NORMAL).setOrigin(0.5, 0.5);

        this.add([shield, titleText]);
        this.alpha = 0;
        this.depth = 10000;
    }

    public show() {
        this.scene.add.existing(this);

        let self = this;
        this.scene!.tweens.chain({
            targets: self,
            tweens: [{
            },
                {
                    y: self.y + 3,
                    delay: 700,
                    alpha: 1,
                    duration: 500,
                },
                {
                    y: self.y + 9,
                    duration: 1000,
                },
                {
                    y: self.y - 6,
                    duration: 1500
                },
                {
                    y: self.y - 12,
                    alpha: 0,
                    duration: 1500,
                    onComplete() {
                        self.destroy();
                    }
                }]
        });
    }

}
